import React, { useState } from "react";
import alumniImg from "../../Assets/alumni screen.svg";
import alumniTop from "../../Assets/svg/alumni-top.svg";
import Button from "../modules/Button";
import ImageCarousel from "../ApplicationPreview/ImageCarousel";
// import ImageCarousel from "./Carousel";
import { useNavigate } from "react-router-dom";

function AlumniOption() {
  const navigate = useNavigate();
const [item, setItem] = useState('');
  return (
    <div className="alumni-screen">
      {/* <img src={alumniImg} alt="alumni img" /> */}
      <img src={alumniTop} alt="alumni img" />
      {/* <ImageCarousel/> */}
      <ImageCarousel setId={(e)=>setItem(e)} />
      <div className="person-info">
        <div className="set-title">{item?.name || item?.fullName}</div>
        <div className="subTitle top">{item?.expertise}</div>
        <div className="bar" />
        <div className="subTitle btm">{item?.college}</div>
      </div>
      <Button
        onClickHandler={() => navigate("/application/connect/alumni")}
        type={"contained"}
        value={"View all alumni"}
      />
    </div>
  );
}

export default AlumniOption;
